// =====================================================================
// dimensions-palettes.js — écran Dimensions & poids : PALETTES (23-10-2026) — textes et contrôles PURS
// (étiquette Zebra par palette, BL « détail des palettes ») ; testés par frontend/test/dimensions-palettes.test.mjs.
// Le serveur refait chaque contrôle (services/um-palettes.rules.js) : ici, seulement pour dire le problème AVANT
// d'envoyer, en mots simples.
// =====================================================================

/** Grammes → « 96,4 » (kg, une décimale). */
export function kgDeGrammes(g) {
  const n = Number(g);
  if (g === null || g === undefined || g === '' || !Number.isFinite(n)) return '—';
  return (n / 1000).toLocaleString('fr-BE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}

/** Contrôle d'une palette avant l'envoi → message ou null. */
export function erreurPaletteEcran({ code, genererId, orderRef, weightG, heightCm }) {
  if (!String(orderRef ?? '').trim()) return 'Palette : scannez d\'abord le n° de commande (il est imprimé sur l\'étiquette et sur le BL).';
  if (genererId && String(code ?? '').trim()) return 'Choisissez : scanner l\'étiquette de la palette OU créer un ID — pas les deux.';
  if (!genererId && !String(code ?? '').trim()) return 'Palette : scannez son étiquette, ou « 🏷 Créer un ID palette » si elle n\'en a pas.';
  if (!(Number(weightG) > 0)) return 'Palette : le poids est obligatoire (il est imprimé sur l\'étiquette et sur le BL).';
  if (!(Number(heightCm) > 0)) return 'Palette : la hauteur est obligatoire (elle est imprimée sur l\'étiquette et sur le BL).';
  return null;
}

/** Dernier travail d'impression → { texte, ok } pour une pastille. */
export function etatImpression(impression) {
  if (!impression) return { texte: 'non imprimée', ok: false };
  switch (impression.statut) {
    case 'EN_FILE': return { texte: '⏳ en file', ok: true };
    case 'EN_COURS': return { texte: '🖨 en cours', ok: true };
    case 'FAIT': return { texte: '✓ imprimée', ok: true };
    case 'ECHEC': return { texte: `⚠ échec${impression.erreur ? ` : ${impression.erreur}` : ''}`, ok: false };
    default: return { texte: String(impression.statut || '—'), ok: false };
  }
}

/** Réponse d'impression d'une étiquette → { texte, url, ok } (message sous le formulaire). */
export function messageEtiquette(r, numero) {
  const quoi = `Étiquette de la palette ${numero ?? '?'}`;
  const url = r?.document?.url || null;
  if (r?.travail) return { texte: `🏷 ${quoi} envoyée à la Zebra du quai.`, url, ok: true };
  return { texte: `⚠ ${quoi} non imprimée : ${r?.message || 'impression indisponible'}${url ? ' — imprimez-la avec « Ouvrir ».' : ''}`, url, ok: false };
}
